(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = e.target.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page: auto update on quantity change ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var fd = new FormData(cartForm);
        fd.delete('checkout');
        fetch(window.themeSettings.routes.cart + '/update.js', { method: 'POST', body: fd })
          .then(function () { window.location.reload(); })
          .catch(function () { cartForm.submit(); });
      }, 400);
    });
  }

  /* ---------- Product sections ---------- */
  function formatMoney(cents, template) {
    var fmt = template || (window.themeSettings && themeSettings.moneyFormat) || '{{amount}}';
    function num(n, dec, t, d) {
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (p[1] ? d + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  function initProduct(root) {
    var jsonEl = root.parentElement.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var gallery = root.querySelector('[data-gallery]');
    var picker = root.querySelector('[data-variant-picker]');
    var idInputs = root.querySelectorAll('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var badgeEl = root.querySelector('[data-badge]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var showCode = priceEl && priceEl.hasAttribute('data-with-currency');
    var moneyTpl = showCode ? window.themeSettings.moneyWithCurrencyFormat : window.themeSettings.moneyFormat;

    // Gallery
    function showMedia(id) {
      if (!gallery || !id) return;
      var slides = gallery.querySelectorAll('.gallery__slide');
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.dataset.mediaId) === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (!found && slides[0]) slides[0].classList.add('is-active');
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.thumb) === String(id));
      });
    }
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var th = e.target.closest('[data-thumb]');
        if (th) showMedia(th.dataset.thumb);
      });
      // swipe on main image (mobile)
      var main = gallery.querySelector('.gallery__main'), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 40) return;
          var slides = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__slide'));
          var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
          var n = (i + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
          showMedia(slides[n].dataset.mediaId);
        });
      }
    }

    if (!picker) return;

    function selectedOptions() {
      var opts = [];
      picker.querySelectorAll('.variant-picker').forEach(function (fs) {
        var sel = fs.querySelector('[data-option-select]');
        var checked = fs.querySelector('[data-option-input]:checked');
        opts.push(sel ? sel.value : (checked ? checked.value : null));
      });
      return opts;
    }

    function updateAvailability(opts) {
      // Mark option values that have no available variant, given the other selections
      picker.querySelectorAll('.variant-picker').forEach(function (fs, idx) {
        fs.querySelectorAll('[data-option-input]').forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx ? o === input.value : (i > idx ? true : o === test[i]); });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function onChange() {
      var opts = selectedOptions();
      picker.querySelectorAll('.variant-picker').forEach(function (fs, i) {
        var lbl = fs.querySelector('[data-selected-value]');
        if (lbl) lbl.textContent = opts[i] || '';
      });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      updateAvailability(opts);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Niedostępny';
        return;
      }
      idInputs.forEach(function (i) { i.value = variant.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyTpl);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price, moneyTpl) : '';
      }
      if (badgeEl) {
        badgeEl.hidden = !onSale;
        if (onSale) {
          var style = badgeEl.dataset.badgeStyle;
          if (style === 'amount') badgeEl.textContent = 'Oszcz\u0119dzasz ' + formatMoney(variant.compare_at_price - variant.price, moneyTpl);
          else if (style === 'text') badgeEl.textContent = badgeEl.dataset.badgeText;
          else badgeEl.textContent = 'Oszcz\u0119dzasz ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? addLabel.dataset.availableLabel : addLabel.dataset.soldoutLabel;
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    picker.addEventListener('change', onChange);
    updateAvailability(selectedOptions());
  }

  document.querySelectorAll('[data-product-section]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product-section]').forEach(initProduct);
  });

  /* ---------- Refresh cart count when apps add to cart ---------- */
  function refreshCount() {
    fetch(window.themeSettings.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }
  document.addEventListener('cart:updated', refreshCount);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
})();

/* Close mobile menu after tapping an anchor link */
document.addEventListener('click', function (e) {
  var a = e.target.closest('[data-close-menu]');
  if (!a) return;
  var nav = a.closest('.mobile-nav');
  if (nav) nav.classList.remove('is-open');
  var btn = document.querySelector('[data-menu-toggle]');
  if (btn) btn.setAttribute('aria-expanded', 'false');
});

/* ---------- Bundle offer ---------- */
(function () {
  function thumbFor(select) {
    var opt = select.options[select.selectedIndex];
    var wrap = select.closest('.bundle-color');
    var img = wrap && wrap.querySelector('[data-bundle-thumb] img');
    var src = opt && opt.getAttribute('data-img');
    if (!wrap || !src) return;
    if (!img) { img = document.createElement('img'); img.alt = ''; wrap.querySelector('[data-bundle-thumb]').appendChild(img); }
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; img.alt = opt.text;
  }
  function showMediaInGallery(section, mediaId) {
    if (!mediaId) return;
    var t = section.querySelector('[data-thumb="' + mediaId + '"]');
    if (t) t.click();
  }
  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    var section = bundle.closest('[data-product-section]');
    var tiers = bundle.querySelectorAll('[data-tier]');
    function refresh() {
      tiers.forEach(function (t) {
        var r = t.querySelector('input[type=radio]');
        t.classList.toggle('is-selected', r.checked);
      });
      var sel = bundle.querySelector('.is-selected [data-bundle-select]');
      if (sel) {
        var hid = section && section.querySelector('[data-variant-id]');
        if (hid) hid.value = sel.value;
      }
    }
    bundle.addEventListener('change', function (e) {
      if (e.target.matches('[data-bundle-select]')) {
        thumbFor(e.target);
        showMediaInGallery(section, e.target.options[e.target.selectedIndex].getAttribute('data-media'));
      }
      refresh();
    });
    refresh();

    var form = section && (section.querySelector('form[data-type="add-to-cart-form"]') || section.querySelector('form[action*="/cart/add"]'));
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      var err = form.querySelector('.buy__error');
      var counts = {};
      bundle.querySelectorAll('.is-selected [data-bundle-select]').forEach(function (s) {
        counts[s.value] = (counts[s.value] || 0) + 1;
      });
      if (!Object.keys(counts).length) {
        var hid = form.querySelector('[data-variant-id]');
        var chk = bundle.querySelector('input[type=radio]:checked');
        counts[hid.value] = chk ? Math.max(1, Number(chk.getAttribute('data-qty') || 1)) : 1;
      }
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      var gift = Number(bundle.getAttribute('data-gift-variant') || 0);
      var gmin = Number(bundle.getAttribute('data-gift-min') || 1);
      var tq = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      if (tq < gmin) gift = 0;
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch(window.themeSettings.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        var hasGift = gift && cart.items.some(function (i) { return i.variant_id === gift; });
        if (gift && !hasGift) items.push({ id: gift, quantity: 1 });
        return fetch(window.themeSettings.routes.cartAdd + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Coś poszło nie tak'); });
        if (window.themeSettings.cartType === 'checkout') { window.location.href = '/checkout'; return; }
        if (window.BNCart && window.BNCart.enabled()) { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } window.BNCart.open(); return; }
        window.location.href = window.themeSettings.routes.cart;
      }).catch(function (ex) {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (!err) { err = document.createElement('p'); err.className = 'buy__error'; form.appendChild(err); }
        err.textContent = ex.message;
      });
    });
  });
})();

/* ---------- Free gift: keep exactly 1 when cart has other products ---------- */
(function () {
  var gift = window.themeSettings && Number(window.themeSettings.giftVariantId || 0);
  if (!gift || !document.querySelector('[data-cart-form]')) return;
  fetch(window.themeSettings.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
    var giftLine = cart.items.find(function (i) { return i.variant_id === gift; });
    var others = cart.items.reduce(function (s, i) { return s + (i.variant_id !== gift ? i.quantity : 0); }, 0);
    var target = others >= Number(window.themeSettings.giftMinQty || 1) ? 1 : 0;
    var current = giftLine ? giftLine.quantity : 0;
    if (current === target) return;
    var req = current === 0
      ? fetch(window.themeSettings.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: gift, quantity: 1 }] }) })
      : fetch(window.themeSettings.routes.cart + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: giftLine.key, quantity: target }) });
    req.then(function () { window.location.reload(); });
  });
})();

/* ---------- Gallery arrows + counter ---------- */
document.querySelectorAll('[data-gallery]').forEach(function (g) {
  function slides() { return Array.prototype.slice.call(g.querySelectorAll('.gallery__slide')); }
  function go(dir) {
    var s = slides(); var i = s.findIndex(function (x) { return x.classList.contains('is-active'); });
    var n = (i + dir + s.length) % s.length;
    var t = g.querySelector('[data-thumb="' + s[n].dataset.mediaId + '"]');
    if (t) { t.click(); t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
    else { s.forEach(function (x, k) { x.classList.toggle('is-active', k === n); }); update(); }
  }
  function update() {
    var s = slides(); var i = s.findIndex(function (x) { return x.classList.contains('is-active'); });
    var c = g.querySelector('[data-gallery-count]'); if (c) c.textContent = (i + 1) + ' / ' + s.length;
  }
  var p = g.querySelector('[data-gallery-prev]'), n = g.querySelector('[data-gallery-next]');
  if (p) p.addEventListener('click', function () { go(-1); });
  if (n) n.addEventListener('click', function () { go(1); });
  new MutationObserver(update).observe(g, { attributes: true, subtree: true, attributeFilter: ['class'] });
});

/* ---------- Mobile sticky "choose bundle" bar ---------- */
(function () {
  var bar = document.querySelector('[data-sticky-cta]');
  var target = document.querySelector('#paket') || document.querySelector('[data-add-button]');
  if (!bar || !target || !('IntersectionObserver' in window)) return;
  var targetVisible = false, pastTop = false;
  function upd() { var show = !targetVisible && pastTop; bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); }
  new IntersectionObserver(function (en) { targetVisible = en[0].isIntersecting; upd(); }).observe(target);
  window.addEventListener('scroll', function () { pastTop = window.scrollY > 250; upd(); }, { passive: true });
  bar.querySelector('[data-sticky-cta-btn]').addEventListener('click', function (e) {
    e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* ---------- Review slider arrows (mobile) ---------- */
document.querySelectorAll('[data-slider-nav]').forEach(function (nav) {
  var track = document.getElementById(nav.getAttribute('data-slider-nav'));
  if (!track) return;
  nav.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dir]'); if (!b) return;
    var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 12 : 300;
    track.scrollBy({ left: w * Number(b.getAttribute('data-dir')), behavior: 'smooth' });
  });
});

/* ---------- Cart: remove a grouped line (several colors) ---------- */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-remove-keys]'); if (!b) return;
  var updates = {};
  b.getAttribute('data-remove-keys').split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
  b.disabled = true;
  fetch(window.themeSettings.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
    .then(function () { window.location.reload(); });
});

/* ==========================================================
   Countdown timer (announcement bar + cart drawer)
   ========================================================== */
(function () {
  var bar = document.querySelector('[data-timer-bar]');
  var minutes = Number((bar && bar.getAttribute('data-minutes')) || 5);
  var KEY = 'bn_timer_end';
  var end;
  try { end = Number(sessionStorage.getItem(KEY)); } catch (e) {}
  if (!end || isNaN(end)) {
    end = Date.now() + minutes * 60000;
    try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = Math.max(0, Math.round((end - Date.now()) / 1000));
    var txt = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    document.querySelectorAll('[data-timer]').forEach(function (el) { el.textContent = txt; });
    if (left === 0) {
      if (bar && bar.getAttribute('data-expired')) {
        var lbl = bar.querySelector('[data-timer-label]');
        if (lbl && !lbl.dataset.done) { lbl.textContent = bar.getAttribute('data-expired'); lbl.dataset.done = '1'; }
      }
      document.querySelectorAll('[data-cd-timer-wrap]').forEach(function (w) { w.hidden = true; });
      clearInterval(iv);
    }
  }
  var iv = setInterval(tick, 1000);
  tick();
})();

/* ==========================================================
   Cart drawer
   ========================================================== */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var TS = window.themeSettings || {};
  var gift = Number(TS.giftVariantId || 0);
  var compare = {};
  try { compare = JSON.parse(drawer.querySelector('[data-compare-map]').textContent); } catch (e) {}
  var vmap = {};
  try { vmap = JSON.parse(drawer.querySelector('[data-variant-map]').textContent); } catch (e) {}
  function money(c) { return formatMoney(c); }
  function formatMoney(cents) {
    var fmt = TS.moneyFormat || '{{amount}} zł';
    var n = (cents / 100);
    var whole = Math.round(n) === n;
    function num(dec, t, d) { var s = n.toFixed(dec).split('.'); return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (s[1] ? d + s[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('no_decimals') > -1 || whole) return num(0, k.indexOf('comma') > -1 ? '.' : ' ', ',');
      if (k.indexOf('comma') > -1) return num(2, '.', ',');
      return num(2, ' ', ',');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function getCart() { return fetch(TS.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(TS.routes.cart + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function syncGift(cart) {
    if (!gift) return Promise.resolve(cart);
    var line = cart.items.find(function (i) { return i.variant_id === gift; });
    var packs = cart.items.reduce(function (s, i) { return s + (i.variant_id !== gift ? i.quantity : 0); }, 0);
    var target = packs >= Number(TS.giftMinQty || 1) ? 1 : 0, cur = line ? line.quantity : 0;
    if (cur === target) return Promise.resolve(cart);
    var req = cur === 0 ? fetch(TS.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: gift, quantity: 1 }] }) })
                        : post('/change.js', { id: line.key, quantity: target });
    return req.then(getCart);
  }
  function setCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }

  window.BNCart = {
    enabled: function () { return !!drawer; },
    open: function () { if (!drawer) return; render(); show(true); },
    refresh: function () { return render(); }
  };
  if (!drawer) return;

  var panel = drawer.querySelector('.cart-drawer__panel');
  var body = drawer.querySelector('[data-cd-body]');
  var lastFocus = null;
  function show(on) {
    drawer.classList.toggle('is-open', on);
    drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.documentElement.classList.toggle('cd-lock', on);
    if (on) { lastFocus = document.activeElement; setTimeout(function () { panel.focus(); }, 50); }
    else if (lastFocus) { lastFocus.focus(); }
  }

  function render() {
    body.classList.add('is-busy');
    return getCart().then(syncGift).then(function (cart) {
      body.classList.remove('is-busy');
      setCount(cart.item_count);
      drawer.querySelector('[data-cd-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      var foot = drawer.querySelector('[data-cd-foot]');
      var offer = drawer.querySelector('[data-cd-offer]');
      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Tw\u00f3j koszyk jest pusty.</p><a class="btn" href="/products/nasal-stick">Kup teraz</a></div>';
        foot.hidden = true; offer.hidden = true; return;
      }
      foot.hidden = false;
      var pens = 0, saved = 0, html = '';
      cart.items.forEach(function (it) {
        var isGift = it.variant_id === gift;
        if (!isGift) pens += it.quantity;
        var cmp = compare[String(it.variant_id)];
        var lineCompare = cmp ? cmp * it.quantity : it.original_line_price;
        saved += Math.max(0, lineCompare - it.final_line_price);
        var showStrike = lineCompare > it.final_line_price;
        // Free units from "Köp X få Y" tiers: show paid and free as separate rows
        var freeN = 0;
        if (!isGift) {
          (drawer.dataset.tiers || '').split(',').forEach(function (t) {
            var a = t.split(':'), tq = Number(a[0]), m = (a[2] || '').match(/(?:f\u00e5|\+)\s*(\d+)/i);
            if (m && it.quantity === tq) freeN = Number(m[1]);
          });
        }
        var dispQty = it.quantity - freeN;
        if (freeN) { lineCompare = cmp ? cmp * dispQty : Math.round(it.original_line_price * dispQty / it.quantity); showStrike = lineCompare > it.final_line_price; }
        html += '<div class="cd-line' + (isGift ? ' cd-line--gift' : '') + '">' +
          '<div class="cd-line__img">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</div>' +
          '<div class="cd-line__info">' +
            '<p class="cd-line__title">' + esc(it.product_title) + '</p>' +
            (it.variant_title && !isGift && vmap[String(it.product_id)] ? (vmap[String(it.product_id)] ? '<button type="button" class="cd-line__variant cd-line__variant--btn" data-cd-swap="' + esc(it.key) + '" data-pid="' + it.product_id + '" data-vid="' + it.variant_id + '" data-q="' + it.quantity + '">' + esc(it.variant_title) + ' <span aria-hidden="true">\u2304</span><span class="visually-hidden"> \u2013 zmie\u0144 kolor</span></button>' : '<p class="cd-line__variant">' + esc(it.variant_title) + '</p>') : '') +
            (isGift ? '<p class="cd-line__gift-tag">W zestawie z zam\u00f3wieniem</p>' :
              '<div class="cd-qty"><button type="button" data-cd-change="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Zmniejsz">\u2212</button>' +
              '<span>' + dispQty + '</span>' +
              (vmap[String(it.product_id)] ? '<button type="button" data-cd-add-color data-pid="' + it.product_id + '" data-vid="' + it.variant_id + '" aria-label="Dodaj jeszcze jeden">+</button></div>' : '<button type="button" data-cd-change="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Zwi\u0119ksz">+</button></div>')) +
          '</div>' +
          '<div class="cd-line__price">' +
            (isGift ? (showStrike ? '<s>' + money(lineCompare) + '</s>' : '') + '<strong class="cd-free">GRATIS</strong>'
                    : (showStrike ? '<s>' + money(lineCompare) + '</s>' : '') + '<strong>' + money(it.final_line_price) + '</strong>') +
            (!isGift ? '<button type="button" class="cd-remove" data-cd-change="' + esc(it.key) + '" data-qty="0" aria-label="Usu\u0144">Usu\u0144</button>' : '') +
          '</div>' +
        '</div>';
        if (freeN) {
          var freeCmp = cmp ? cmp * freeN : 0;
          html += '<div class="cd-line cd-line--gift cd-line--free">' +
            '<div class="cd-line__img">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</div>' +
            '<div class="cd-line__info"><p class="cd-line__title">' + esc(it.product_title) + '</p><p class="cd-line__gift-tag">' + freeN + ' szt. gratis</p></div>' +
            '<div class="cd-line__price">' + (freeCmp ? '<s>' + money(freeCmp) + '</s>' : '') + '<strong class="cd-free">0 z\u0142</strong></div>' +
          '</div>';
        }
      });
      var penLine = cart.items.find(function (i) { return i.variant_id !== gift && vmap[String(i.product_id)]; });
      if (penLine) html += '<button type="button" class="cd-add-color" data-cd-add-color data-pid="' + penLine.product_id + '" data-vid="">+ Dodaj kolejny kolor</button>';
      body.innerHTML = html;
      // offer message + progress
      var tiers = (drawer.dataset.tiers || '').split(',').map(function (t) { var a = t.split(':'); return { q: Number(a[0]), p: (a[1] || '').trim(), l: (a[2] || '').trim() }; }).filter(function (t) { return t.q; });
      var maxQ = tiers.length ? tiers[tiers.length - 1].q : 5;
      var next = tiers.find(function (t) { return t.q > pens; });
      var msg = next ? (next.l ? next.l + ' gratis – zap\u0142a\u0107 tylko ' + next.p + ' z\u0142' : (drawer.dataset.msgNext || '').replace('[antal]', next.q).replace('[pris]', next.p)) : drawer.dataset.msg3;
      offer.hidden = !pens || !msg;
      drawer.querySelector('[data-cd-offer-text]').textContent = msg || '';
      offer.classList.toggle('is-done', !next);
      var first = tiers.length ? tiers[0].q : 1;
      var pct = Math.max(0, Math.min(100, (pens - first) / Math.max(1, maxQ - first) * 100));
      drawer.querySelector('[data-cd-bar]').style.width = pct + '%';
      drawer.querySelectorAll('[data-mark]').forEach(function (m) { var q = Number(m.getAttribute('data-mark')); m.classList.toggle('is-hit', pens >= q); m.classList.toggle('is-current', pens === q || (!next && q === maxQ)); });
      var sr = drawer.querySelector('[data-cd-save-row]');
      sr.hidden = saved <= 0;
      drawer.querySelector('[data-cd-save]').textContent = '\u2212' + money(saved);
      drawer.querySelector('[data-cd-total]').textContent = money(cart.total_price);
    }).catch(function () { body.classList.remove('is-busy'); });
  }

  var picker = drawer.querySelector('[data-cd-picker]');
  var pickerState = null;
  function openPicker(mode, pid, vid, key, qty) {
    var list = vmap[String(pid)] || [];
    pickerState = { mode: mode, key: key, qty: qty, vid: Number(vid) || 0 };
    drawer.querySelector('[data-cd-picker-title]').textContent = mode === 'swap' ? 'Zmie\u0144 na kt\u00f3ry kolor?' : 'Jaki kolor chcesz doda\u0107?';
    drawer.querySelector('[data-cd-picker-grid]').innerHTML = list.map(function (v) {
      var cur = v.id === pickerState.vid;
      return '<button type="button" class="cd-swatch' + (cur ? ' is-current' : '') + '" data-pick="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' +
        '<span class="cd-swatch__img">' + (v.i ? '<img src="' + esc(v.i) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
        '<span class="cd-swatch__name">' + esc(v.t) + '</span>' +
        (cur ? '<span class="cd-swatch__tag">' + (mode === 'swap' ? 'Nuvarande' : 'Samma igen') + '</span>' : '') + '</button>';
    }).join('');
    picker.hidden = false;
    requestAnimationFrame(function () { picker.classList.add('is-open'); });
    var first = picker.querySelector('[data-pick]:not([disabled])'); if (first) first.focus();
  }
  function closePicker() { picker.classList.remove('is-open'); setTimeout(function () { picker.hidden = true; }, 200); pickerState = null; }
  function addVariant(id) { return fetch(TS.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) }); }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-picker-close]') || e.target === picker) { closePicker(); return; }
    var pick = e.target.closest('[data-pick]');
    if (pick && pickerState) {
      var st = pickerState, id = Number(pick.getAttribute('data-pick'));
      closePicker();
      if (st.mode === 'swap' && id === st.vid) return;
      body.classList.add('is-busy');
      var job = addVariant(id);
      if (st.mode === 'swap') job = job.then(function () { return post('/change.js', { id: st.key, quantity: Math.max(0, st.qty - 1) }); });
      job.then(render);
      return;
    }
    var addc = e.target.closest('[data-cd-add-color]');
    if (addc) { openPicker('add', addc.getAttribute('data-pid'), addc.getAttribute('data-vid')); return; }
    var sw = e.target.closest('[data-cd-swap]');
    if (sw) { openPicker('swap', sw.getAttribute('data-pid'), sw.getAttribute('data-vid'), sw.getAttribute('data-cd-swap'), Number(sw.getAttribute('data-q'))); return; }
    if (e.target.closest('[data-cart-close]')) { show(false); return; }
    var ch = e.target.closest('[data-cd-change]');
    if (ch) {
      body.classList.add('is-busy');
      post('/change.js', { id: ch.getAttribute('data-cd-change'), quantity: Math.max(0, Number(ch.getAttribute('data-qty'))) }).then(render);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
    if (pickerState) closePicker(); else show(false);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-link]');
    if (a) { e.preventDefault(); window.BNCart.open(); }
  });
})();
